import React from 'react';
import MonacoEditor from './react-monaco-editor/editor';

class MonacoEditorView extends React.Component {
    constructor(props) {
        super(props);
        this.updateCodeMirrorCSS = this.updateCodeMirrorCSS.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        this.updateCodeMirrorCSS();
    }

    componentDidMount() {
        this.updateCodeMirrorCSS();
    }

    updateCodeMirrorCSS() {
        //Adjust code mirror's height
        let scCodeMirrorElements = document.getElementsByClassName("scCodeMirrorClass");
        if (scCodeMirrorElements) {
            for (let i = 0; i < scCodeMirrorElements.length; i++) {
                let element = scCodeMirrorElements.item(i);
                if (this.props.notOnlyShowCodeMirror) {
                    element.classList.remove("scCodeMirrorOnly");
                    element.classList.add("scCodeMirror");
                } else {
                    element.classList.remove("scCodeMirror");
                    element.classList.add("scCodeMirrorOnly");
                }
            }
        }

        this.refs.monaco.editor.layout();

        let selection = this.refs.monaco.editor.getSelection();
        if(selection){
            this.refs.monaco.editor.setSelection(selection.collapseToStart());
        }
    }

    render() {
        const options = {
            readOnly: true,
            contextmenu: false,
            selectOnLineNumbers: true,
            renderLineHighlight: "line",
            scrollBeyondLastLine: false,
            showFoldingControls: "always",
            automaticLayout: true,
            fontSize:'14px'
        };

        return (
            <div className="scCodeMirror scCodeMirrorClass">
                <MonacoEditor
                    ref="monaco"
                    language={this.props.language}
                    theme="vs"
                    value={this.props.code}
                    options={options}
                />
            </div>
        );
    }
}

export default MonacoEditorView;